<template>
  <div>
    <!-- Fondo oscuro del modal secundario -->
    <div v-show="isVisible" class="overlay-internal"></div>

    <!-- Modal de contacto -->
    <md-card v-show="isVisible" class="contacto-modal" @click.stop>
      <!-- Botón de cierre -->
      <button class="close-btn" @click="closeModal">✕</button>

      <!-- Encabezado -->
      <div class="modal-header">
        <h4 class="modal-title">Revisa o edita tu información</h4>
      </div>

      <!-- Contenido -->
      <div class="modal-content">
        <v-text-field
          v-model="inputValue"
          :label="placeholderText"
          outlined
          dense
          :rules="[inputType === 'email' ? emailRule : whatsappRule]"
          :maxlength="inputType === 'whatsapp' ? 10 : null"
          :key="resetKey"
          @input="validateInput"
        ></v-text-field>
      </div>

      <!-- Botón de acción -->
      <v-btn
        block
        class="btn-continuar"
        :disabled="!isInputValid"
        @click="sendInfo"
        >Enviar</v-btn
      >
    </md-card>
    <ModalExito ref="modalExito" />
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script>
import ModalExito from "./ModalExito.vue";
import Loading from "../isep/Tools/loading.vue";

export default {
  name: "ModalContacto",
  components: {
    ModalExito,
    Loading,
  },
  props: {
    inputType: {
      type: String,
      default: "whatsapp",
    },
    transactionDetails: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isVisible: false,
      inputValue: "",
      isLoading: false,
      errorMessage: "",
      resetKey: 0,
    };
  },
  computed: {
    placeholderText() {
      return this.inputType === "whatsapp"
        ? "Introduce tu número de WhatsApp"
        : "Introduce tu dirección de correo electrónico";
    },
    isInputValid() {
      if (this.inputType === "email") {
        return this.validateEmail(this.inputValue);
      } else if (this.inputType === "whatsapp") {
        return this.validateWhatsapp(this.inputValue);
      }
      return false;
    },
    emailRule() {
      return (value) =>
        this.validateEmail(value) || "Introduce un correo válido.";
    },
    whatsappRule() {
      return (value) =>
        this.validateWhatsapp(value) ||
        "Introduce un número de WhatsApp válido.";
    },
  },
  methods: {
    closeModal() {
      this.isVisible = false;
      this.inputValue = "";
      this.errorMessage = "";
      this.resetKey++;
    },
    sendInfo() {
      if (!this.inputValue) {
        this.$swal(
          "Advertencia",
          "Por favor, introduce la información solicitada.",
          "warning"
        );
        return;
      }

      if (this.inputType === "email") {
        this.enviarCorreo();
      } else if (this.inputType === "whatsapp") {
        this.enviarWhatsapp();
      } else {
        this.$swal(
          "Error",
          "Tipo de entrada no válido. Contacte al soporte.",
          "error"
        );
      }
    },
    openModalContacto() {
      this.isVisible = true;
    },
    validateInput() {
      if (this.inputType === "email") {
        this.errorMessage = this.validateEmail(this.inputValue)
          ? ""
          : "Introduce un correo electrónico válido.";
      } else if (this.inputType === "whatsapp") {
        this.errorMessage = this.validateWhatsapp(this.inputValue)
          ? ""
          : "Introduce un número de WhatsApp válido (10 dígitos).";
      }
    },
    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    validateWhatsapp(phone) {
      const phoneRegex = /^\d{10}$/;
      return phoneRegex.test(phone);
    },
    async enviarWhatsapp() {
      this.isLoading = true;

      const payload = {
        tipoEnvio: 3,
        entSMS: null,
        entEMAIL: null,
        entWhats: {
          destination: this.inputValue,
          parameters: [
            "Estatus del pago",
            this.transactionDetails.fecha || "Fecha no disponible",
            this.transactionDetails.referencia || "Referencia no disponible",
            this.transactionDetails.autorizacion || "Autorización no disponible",
            this.transactionDetails.tarjeta || "Tarjeta no disponible",
            this.transactionDetails.monto || "Monto no disponible",
            this.transactionDetails.plazo || "Plazo no disponible",
          ],
          buttonsParameters: [],
          template: "llink_pago_latino",
          botAttention: false,
          component: {
            header: {
              type: null,
              value: null,
              isBinaryFile: false,
              filename: null,
            },
            buttons: [
              {
                index: 0,
              },
            ],
          },
          IdNumeroSalida: null,
        },
      };


      try {
        const response = await this.$store.dispatch("metodoPost", {
          metodo: "ENVIARWHATSAPP",
          data: payload,
        });

        if (response && response.data) {
          this.$swal(
            "Recibo enviado con éxito, gracias por confiar en Latino Seguros",
            "",
            "success"
          );
        } else {
          console.error("No se encontró una respuesta válida:", response);
          this.$swal(
            "Error",
            "No se pudo enviar el mensaje de WhatsApp. Verifique los datos e intente nuevamente.",
            "error"
          );
        }
      } catch (error) {
        console.error("Error al enviar el mensaje de WhatsApp:", error);
        this.$swal(
          "Error en la Consulta",
          "Ocurrió un error al intentar enviar el mensaje de WhatsApp. Intente nuevamente.",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    async enviarCorreo() {
      this.isLoading = true;
      let id;
      let subject;
      if (this.transactionDetails.autorizacion === "AUTORIZADA") {
        id = 115;
        subject = "Pago Aceptado";
      } else {
        id = 114;
        subject = "Pago Rechazado";
      }
      const payload = {
        idTemplate: id,
        sender: "sistemas.danos@latinoseguros.com.mx",
        subject: subject,
        targets: this.inputValue,
        dinamicContent: `${this.transactionDetails.fecha}|${this.transactionDetails.referencia}|${this.transactionDetails.autorizacion}|${this.transactionDetails.tarjeta}|${this.transactionDetails.monto}|${this.transactionDetails.plazo}`,
        idMessage: id,
      };


      this.isLoading = true;

      try {
        const response = await this.$store.dispatch("metodoPost", {
          metodo: "ENVIARCORREO",
          data: payload,
        });

        if (response && response.data) {
          this.$swal(
            "Recibo enviado con éxito, gracias por confiar en Latino Seguros.",
            "",
            "success"
          );
          //this.$refs.modalExito.openModal();
          this.isLoading = false;
        } else {
          console.error("No se encontró una respuesta válida:", response);
          this.$swal(
            "Error",
            "No se pudo enviar el correo. Verifique los datos e intente nuevamente.",
            "error"
          );
        }
      } catch (error) {
        console.error("Error al enviar el correo:", error);
        this.$swal(
          "Error en la Consulta",
          "Ocurrió un error al intentar enviar el correo. Intente nuevamente.",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Fondo oscuro interno para el modal principal */
.overlay-internal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4); /* Opacidad más tenue */
  z-index: 1010; /* Por encima del modal principal */
}

/* Estilos del modal secundario */
.contacto-modal {
  max-width: 280px;
  width: 90%; /* Opcional para dispositivos pequeños */
  padding: 16px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  position: fixed; /* Centrado respecto a toda la pantalla */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Centra el modal */
  z-index: 1020;
}

.modal-header {
  text-align: center;
  margin-bottom: 20px;
}

.modal-title {
  font-size: 15px;
  color: #003366;
  font-weight: bold;
}

.close-btn {
  position: absolute; /* Posiciona el botón dentro del modal */
  top: 10px; /* Distancia desde la parte superior */
  right: 10px; /* Alineado al lado derecho */
  background: none;
  border: none;
  font-size: 1.5rem; /* Tamaño del botón */
  cursor: pointer;
  color: #003366;
}

.modal-content {
  margin-bottom: 16px;
}

.btn-continuar {
  background-color: #003366 !important;
  color: white !important;
  font-size: 12px;
  padding: 6px 12px;
  height: 32px;
  width: 12px !important;
  line-height: 16px;
  max-height: 32px;
}

.modal-content {
  border: none;
}

/* Reducir el tamaño del texto dentro del v-text-field */
.modal-content >>> .v-input__control {
  font-size: 10px; /* Ajusta el tamaño del texto */
}

.modal-content >>> .v-label {
  font-size: 10px; /* Reduce el tamaño del label (placeholder) */
}

.modal-content >>> input {
  font-size: 10px; /* Aplica directamente al texto ingresado */
}
</style>
